import { __commonJSMin as e } from "../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/dompurify@3.3.1/node_modules/dompurify/dist/purify.cjs.js
var t = /* @__PURE__ */ e(((e, t) => {
	var { entries: n, setPrototypeOf: r, isFrozen: i, getPrototypeOf: a, getOwnPropertyDescriptor: o } = Object, { freeze: s, seal: c, create: l } = Object, { apply: u, construct: d } = typeof Reflect < "u" && Reflect;
	s ||= function(e) {
		return e;
	}, c ||= function(e) {
		return e;
	}, u ||= function(e, t) {
		var n = [...arguments].slice(2);
		return e.apply(t, n);
	}, d ||= function(e) {
		return new e(...[...arguments].slice(1));
	};
	var ee = v(Array.prototype.forEach), te = v(Array.prototype.lastIndexOf), ne = v(Array.prototype.pop), f = v(Array.prototype.push), re = v(Array.prototype.splice), p = v(String.prototype.toLowerCase), ie = v(String.prototype.toString), ae = v(String.prototype.match), m = v(String.prototype.replace), oe = v(String.prototype.indexOf), se = v(String.prototype.trim), h = v(Object.prototype.hasOwnProperty), g = v(RegExp.prototype.test), _ = ce(TypeError);
	function v(e) {
		return function(t) {
			t instanceof RegExp && (t.lastIndex = 0);
			var n = [...arguments].slice(1);
			return u(e, t, n);
		};
	}
	function ce(e) {
		return function() {
			return d(e, [...arguments]);
		};
	}
	function y(e, t) {
		let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : p;
		r && r(e, null);
		let a = t.length;
		for (; a--;) {
			let r = t[a];
			if (typeof r == "string") {
				let e = n(r);
				e !== r && (i(t) || (t[a] = e), r = e);
			}
			e[r] = !0;
		}
		return e;
	}
	function le(e) {
		for (let t = 0; t < e.length; t++) h(e, t) || (e[t] = null);
		return e;
	}
	function b(e) {
		let t = l(null);
		for (let [r, i] of n(e)) h(e, r) && (Array.isArray(i) ? t[r] = le(i) : i && typeof i == "object" && i.constructor === Object ? t[r] = b(i) : t[r] = i);
		return t;
	}
	function x(e, t) {
		for (; e !== null;) {
			let n = o(e, t);
			if (n) {
				if (n.get) return v(n.get);
				if (typeof n.value == "function") return v(n.value);
			}
			e = a(e);
		}
		function n() {
			return null;
		}
		return n;
	}
	var ue = s(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), de = s(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), fe = s([
		"feBlend",
		"feColorMatrix",
		"feComponentTransfer",
		"feComposite",
		"feConvolveMatrix",
		"feDiffuseLighting",
		"feDisplacementMap",
		"feDistantLight",
		"feDropShadow",
		"feFlood",
		"feFuncA",
		"feFuncB",
		"feFuncG",
		"feFuncR",
		"feGaussianBlur",
		"feImage",
		"feMerge",
		"feMergeNode",
		"feMorphology",
		"feOffset",
		"fePointLight",
		"feSpecularLighting",
		"feSpotLight",
		"feTile",
		"feTurbulence"
	]), pe = s([
		"animate",
		"color-profile",
		"cursor",
		"discard",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"foreignobject",
		"hatch",
		"hatchpath",
		"mesh",
		"meshgradient",
		"meshpatch",
		"meshrow",
		"missing-glyph",
		"script",
		"set",
		"solidcolor",
		"unknown",
		"use"
	]), me = s(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), he = s([
		"maction",
		"maligngroup",
		"malignmark",
		"mlongdiv",
		"mscarries",
		"mscarry",
		"msgroup",
		"mstack",
		"msline",
		"msrow",
		"semantics",
		"annotation",
		"annotation-xml",
		"mprescripts",
		"none"
	]), ge = s(["#text"]), _e = s(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns.slot".split(".")), ve = s(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), ye = s(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnsalign.columnlines.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lspace.lquote.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), be = s([
		"xlink:href",
		"xml:id",
		"xlink:title",
		"xml:space",
		"xmlns:xlink"
	]), xe = c(/\{\{[\w\W]*|[\w\W]*\}\}/gm), S = c(/<%[\w\W]*|[\w\W]*%>/gm), C = c(/\$\{[\w\W]*/gm), Se = c(/^data-[\-\w.\u00B7-\uFFFF]+$/), Ce = c(/^aria-[\-\w]+$/), we = c(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Te = c(/^(?:\w+script|data):/i), Ee = c(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), De = c(/^html$/i), w = c(/^[a-z][.\w]*(-[.\w]+)+$/i), Oe = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		ARIA_ATTR: Ce,
		ATTR_WHITESPACE: Ee,
		CUSTOM_ELEMENT: w,
		DATA_ATTR: Se,
		DOCTYPE_NAME: De,
		ERB_EXPR: S,
		IS_ALLOWED_URI: we,
		IS_SCRIPT_OR_DATA: Te,
		MUSTACHE_EXPR: xe,
		TMPLIT_EXPR: C
	}), T = {
		element: 1,
		attribute: 2,
		text: 3,
		cdataSection: 4,
		entityReference: 5,
		entityNode: 6,
		progressingInstruction: 7,
		comment: 8,
		document: 9,
		documentType: 10,
		documentFragment: 11,
		notation: 12
	}, ke = function() {
		return typeof window > "u" ? null : window;
	}, Ae = function(e, t) {
		if (typeof e != "object" || typeof e.createPolicy != "function") return null;
		let n = null, r = "data-tt-policy-suffix";
		t && t.hasAttribute(r) && (n = t.getAttribute(r));
		let i = "dompurify" + (n ? "#" + n : "");
		try {
			return e.createPolicy(i, {
				createHTML(e) {
					return e;
				},
				createScriptURL(e) {
					return e;
				}
			});
		} catch {
			return console.warn("TrustedTypes policy " + i + " could not be created."), null;
		}
	}, je = function() {
		return {
			afterSanitizeAttributes: [],
			afterSanitizeElements: [],
			afterSanitizeShadowDOM: [],
			beforeSanitizeAttributes: [],
			beforeSanitizeElements: [],
			beforeSanitizeShadowDOM: [],
			uponSanitizeAttribute: [],
			uponSanitizeElement: [],
			uponSanitizeShadowNode: []
		};
	};
	function Me() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ke(), t = (e) => Me(e);
		if (t.version = "3.3.1", t.removed = [], !e || !e.document || e.document.nodeType !== T.document || !e.Element) return t.isSupported = !1, t;
		let { document: r } = e, i = r, a = i.currentScript, { DocumentFragment: o, HTMLTemplateElement: c, Node: u, Element: d, NodeFilter: v, NamedNodeMap: ce = e.NamedNodeMap || e.MozNamedAttrMap, HTMLFormElement: le, DOMParser: xe, trustedTypes: S } = e, C = d.prototype, Se = x(C, "cloneNode"), Ce = x(C, "remove"), Te = x(C, "nextSibling"), Ee = x(C, "childNodes"), w = x(C, "parentNode");
		if (typeof c == "function") {
			let e = r.createElement("template");
			e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
		}
		let E, D = "", { implementation: Ne, createNodeIterator: Pe, createDocumentFragment: Fe, getElementsByTagName: Ie } = r, { importNode: Le } = i, O = je();
		t.isSupported = typeof n == "function" && typeof w == "function" && Ne && Ne.createHTMLDocument !== void 0;
		let { MUSTACHE_EXPR: Re, ERB_EXPR: ze, TMPLIT_EXPR: Be, DATA_ATTR: Ve, ARIA_ATTR: He, IS_SCRIPT_OR_DATA: Ue, ATTR_WHITESPACE: We, CUSTOM_ELEMENT: Ge } = Oe, { IS_ALLOWED_URI: Ke } = Oe, k = null, qe = y({}, [
			...ue,
			...de,
			...fe,
			...me,
			...ge
		]), A = null, Je = y({}, [
			..._e,
			...ve,
			...ye,
			...be
		]), j = Object.seal(l(null, {
			tagNameCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			attributeNameCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			allowCustomizedBuiltInElements: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: !1
			}
		})), M = null, Ye = null, N = Object.seal(l(null, {
			tagCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			attributeCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			}
		})), Xe = !0, Ze = !0, Qe = !1, $e = !0, P = !1, F = !0, I = !1, et = !1, tt = !1, L = !1, R = !1, z = !1, nt = !0, rt = !1, it = !0, B = !1, V = {}, H = null, at = y({}, [
			"annotation-xml",
			"audio",
			"colgroup",
			"desc",
			"foreignobject",
			"head",
			"iframe",
			"math",
			"mi",
			"mn",
			"mo",
			"ms",
			"mtext",
			"noembed",
			"noframes",
			"noscript",
			"plaintext",
			"script",
			"style",
			"svg",
			"template",
			"thead",
			"title",
			"video",
			"xmp"
		]), ot = null, st = y({}, [
			"audio",
			"video",
			"img",
			"source",
			"image",
			"track"
		]), ct = null, lt = y({}, [
			"alt",
			"class",
			"for",
			"id",
			"label",
			"name",
			"pattern",
			"placeholder",
			"role",
			"summary",
			"title",
			"value",
			"style",
			"xmlns"
		]), U = "http://www.w3.org/1998/Math/MathML", W = "http://www.w3.org/2000/svg", G = "http://www.w3.org/1999/xhtml", K = G, ut = !1, dt = null, ft = y({}, [
			U,
			W,
			G
		], ie), pt = y({}, [
			"mi",
			"mo",
			"mn",
			"ms",
			"mtext"
		]), q = y({}, ["annotation-xml"]), mt = y({}, [
			"title",
			"style",
			"font",
			"a",
			"script"
		]), J = null, ht = ["application/xhtml+xml", "text/html"], Y = null, X = null, gt = r.createElement("form"), _t = function(e) {
			return e instanceof RegExp || e instanceof Function;
		}, vt = function() {
			let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			if (!(X && X === e)) {
				if ((!e || typeof e != "object") && (e = {}), e = b(e), J = ht.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Y = J === "application/xhtml+xml" ? ie : p, k = h(e, "ALLOWED_TAGS") ? y({}, e.ALLOWED_TAGS, Y) : qe, A = h(e, "ALLOWED_ATTR") ? y({}, e.ALLOWED_ATTR, Y) : Je, dt = h(e, "ALLOWED_NAMESPACES") ? y({}, e.ALLOWED_NAMESPACES, ie) : ft, ct = h(e, "ADD_URI_SAFE_ATTR") ? y(b(lt), e.ADD_URI_SAFE_ATTR, Y) : lt, ot = h(e, "ADD_DATA_URI_TAGS") ? y(b(st), e.ADD_DATA_URI_TAGS, Y) : st, H = h(e, "FORBID_CONTENTS") ? y({}, e.FORBID_CONTENTS, Y) : at, M = h(e, "FORBID_TAGS") ? y({}, e.FORBID_TAGS, Y) : b({}), Ye = h(e, "FORBID_ATTR") ? y({}, e.FORBID_ATTR, Y) : b({}), V = h(e, "USE_PROFILES") ? e.USE_PROFILES : !1, Xe = e.ALLOW_ARIA_ATTR !== !1, Ze = e.ALLOW_DATA_ATTR !== !1, Qe = e.ALLOW_UNKNOWN_PROTOCOLS || !1, $e = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, P = e.SAFE_FOR_TEMPLATES || !1, F = e.SAFE_FOR_XML !== !1, I = e.WHOLE_DOCUMENT || !1, L = e.RETURN_DOM || !1, R = e.RETURN_DOM_FRAGMENT || !1, z = e.RETURN_TRUSTED_TYPE || !1, tt = e.FORCE_BODY || !1, nt = e.SANITIZE_DOM !== !1, rt = e.SANITIZE_NAMED_PROPS || !1, it = e.KEEP_CONTENT !== !1, B = e.IN_PLACE || !1, Ke = e.ALLOWED_URI_REGEXP || we, K = e.NAMESPACE || G, pt = e.MATHML_TEXT_INTEGRATION_POINTS || pt, q = e.HTML_INTEGRATION_POINTS || q, j = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && _t(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (j.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && _t(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (j.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (j.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), P && (Ze = !1), R && (L = !0), V && (k = y({}, ge), A = [], V.html === !0 && (y(k, ue), y(A, _e)), V.svg === !0 && (y(k, de), y(A, ve), y(A, be)), V.svgFilters === !0 && (y(k, fe), y(A, ve), y(A, be)), V.mathMl === !0 && (y(k, me), y(A, ye), y(A, be))), e.ADD_TAGS && (typeof e.ADD_TAGS == "function" ? N.tagCheck = e.ADD_TAGS : (k === qe && (k = b(k)), y(k, e.ADD_TAGS, Y))), e.ADD_ATTR && (typeof e.ADD_ATTR == "function" ? N.attributeCheck = e.ADD_ATTR : (A === Je && (A = b(A)), y(A, e.ADD_ATTR, Y))), e.ADD_URI_SAFE_ATTR && y(ct, e.ADD_URI_SAFE_ATTR, Y), e.FORBID_CONTENTS && (H === at && (H = b(H)), y(H, e.FORBID_CONTENTS, Y)), e.ADD_FORBID_CONTENTS && (H === at && (H = b(H)), y(H, e.ADD_FORBID_CONTENTS, Y)), it && (k["#text"] = !0), I && y(k, [
					"html",
					"head",
					"body"
				]), k.table && (y(k, ["tbody"]), delete M.tbody), e.TRUSTED_TYPES_POLICY) {
					if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw _("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
					if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw _("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
					E = e.TRUSTED_TYPES_POLICY, D = E.createHTML("");
				} else E === void 0 && (E = Ae(S, a)), E !== null && typeof D == "string" && (D = E.createHTML(""));
				s && s(e), X = e;
			}
		}, yt = y({}, [
			...de,
			...fe,
			...pe
		]), bt = y({}, [...me, ...he]), xt = function(e) {
			let t = w(e);
			(!t || !t.tagName) && (t = {
				namespaceURI: K,
				tagName: "template"
			});
			let n = p(e.tagName), r = p(t.tagName);
			return dt[e.namespaceURI] ? e.namespaceURI === W ? t.namespaceURI === G ? n === "svg" : t.namespaceURI === U ? n === "svg" && (r === "annotation-xml" || pt[r]) : !!yt[n] : e.namespaceURI === U ? t.namespaceURI === G ? n === "math" : t.namespaceURI === W ? n === "math" && q[r] : !!bt[n] : e.namespaceURI === G ? t.namespaceURI === W && !q[r] || t.namespaceURI === U && !pt[r] ? !1 : !bt[n] && (mt[n] || !yt[n]) : !!(J === "application/xhtml+xml" && dt[e.namespaceURI]) : !1;
		}, Z = function(e) {
			f(t.removed, { element: e });
			try {
				w(e).removeChild(e);
			} catch {
				Ce(e);
			}
		}, Q = function(e, n) {
			try {
				f(t.removed, {
					attribute: n.getAttributeNode(e),
					from: n
				});
			} catch {
				f(t.removed, {
					attribute: null,
					from: n
				});
			}
			if (n.removeAttribute(e), e === "is") if (L || R) try {
				Z(n);
			} catch {}
			else try {
				n.setAttribute(e, "");
			} catch {}
		}, St = function(e) {
			let t = null, n = null;
			if (tt) e = "<remove></remove>" + e;
			else {
				let t = ae(e, /^[\r\n\t ]+/);
				n = t && t[0];
			}
			J === "application/xhtml+xml" && K === G && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
			let i = E ? E.createHTML(e) : e;
			if (K === G) try {
				t = new xe().parseFromString(i, J);
			} catch {}
			if (!t || !t.documentElement) {
				t = Ne.createDocument(K, "template", null);
				try {
					t.documentElement.innerHTML = ut ? D : i;
				} catch {}
			}
			let a = t.body || t.documentElement;
			return e && n && a.insertBefore(r.createTextNode(n), a.childNodes[0] || null), K === G ? Ie.call(t, I ? "html" : "body")[0] : I ? t.documentElement : a;
		}, Ct = function(e) {
			return Pe.call(e.ownerDocument || e, e, v.SHOW_ELEMENT | v.SHOW_COMMENT | v.SHOW_TEXT | v.SHOW_PROCESSING_INSTRUCTION | v.SHOW_CDATA_SECTION, null);
		}, wt = function(e) {
			return e instanceof le && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof ce) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
		}, Tt = function(e) {
			return typeof u == "function" && e instanceof u;
		};
		function $(e, n, r) {
			ee(e, (e) => {
				e.call(t, n, r, X);
			});
		}
		let Et = function(e) {
			let n = null;
			if ($(O.beforeSanitizeElements, e, null), wt(e)) return Z(e), !0;
			let r = Y(e.nodeName);
			if ($(O.uponSanitizeElement, e, {
				tagName: r,
				allowedTags: k
			}), F && e.hasChildNodes() && !Tt(e.firstElementChild) && g(/<[/\w!]/g, e.innerHTML) && g(/<[/\w!]/g, e.textContent) || e.nodeType === T.progressingInstruction || F && e.nodeType === T.comment && g(/<[/\w]/g, e.data)) return Z(e), !0;
			if (!(N.tagCheck instanceof Function && N.tagCheck(r)) && (!k[r] || M[r])) {
				if (!M[r] && Ot(r) && (j.tagNameCheck instanceof RegExp && g(j.tagNameCheck, r) || j.tagNameCheck instanceof Function && j.tagNameCheck(r))) return !1;
				if (it && !H[r]) {
					let t = w(e) || e.parentNode, n = Ee(e) || e.childNodes;
					if (n && t) {
						let r = n.length;
						for (let i = r - 1; i >= 0; --i) {
							let r = Se(n[i], !0);
							r.__removalCount = (e.__removalCount || 0) + 1, t.insertBefore(r, Te(e));
						}
					}
				}
				return Z(e), !0;
			}
			return e instanceof d && !xt(e) || (r === "noscript" || r === "noembed" || r === "noframes") && g(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Z(e), !0) : (P && e.nodeType === T.text && (n = e.textContent, ee([
				Re,
				ze,
				Be
			], (e) => {
				n = m(n, e, " ");
			}), e.textContent !== n && (f(t.removed, { element: e.cloneNode() }), e.textContent = n)), $(O.afterSanitizeElements, e, null), !1);
		}, Dt = function(e, t, n) {
			if (nt && (t === "id" || t === "name") && (n in r || n in gt)) return !1;
			if (!(Ze && !Ye[t] && g(Ve, t)) && !(Xe && g(He, t)) && !(N.attributeCheck instanceof Function && N.attributeCheck(t, e))) {
				if (!A[t] || Ye[t]) {
					if (!(Ot(e) && (j.tagNameCheck instanceof RegExp && g(j.tagNameCheck, e) || j.tagNameCheck instanceof Function && j.tagNameCheck(e)) && (j.attributeNameCheck instanceof RegExp && g(j.attributeNameCheck, t) || j.attributeNameCheck instanceof Function && j.attributeNameCheck(t, e)) || t === "is" && j.allowCustomizedBuiltInElements && (j.tagNameCheck instanceof RegExp && g(j.tagNameCheck, n) || j.tagNameCheck instanceof Function && j.tagNameCheck(n)))) return !1;
				} else if (!ct[t] && !g(Ke, m(n, We, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && oe(n, "data:") === 0 && ot[e]) && !(Qe && !g(Ue, m(n, We, ""))) && n) return !1;
			}
			return !0;
		}, Ot = function(e) {
			return e !== "annotation-xml" && ae(e, Ge);
		}, kt = function(e) {
			$(O.beforeSanitizeAttributes, e, null);
			let { attributes: n } = e;
			if (!n || wt(e)) return;
			let r = {
				attrName: "",
				attrValue: "",
				keepAttr: !0,
				allowedAttributes: A,
				forceKeepAttr: void 0
			}, i = n.length;
			for (; i--;) {
				let { name: a, namespaceURI: o, value: s } = n[i], c = Y(a), l = s, u = a === "value" ? l : se(l);
				if (r.attrName = c, r.attrValue = u, r.keepAttr = !0, r.forceKeepAttr = void 0, $(O.uponSanitizeAttribute, e, r), u = r.attrValue, rt && (c === "id" || c === "name") && (Q(a, e), u = "user-content-" + u), F && g(/((--!?|])>)|<\/(style|title|textarea)/i, u)) {
					Q(a, e);
					continue;
				}
				if (c === "attributename" && ae(u, "href")) {
					Q(a, e);
					continue;
				}
				if (r.forceKeepAttr) continue;
				if (!r.keepAttr) {
					Q(a, e);
					continue;
				}
				if (!$e && g(/\/>/i, u)) {
					Q(a, e);
					continue;
				}
				P && ee([
					Re,
					ze,
					Be
				], (e) => {
					u = m(u, e, " ");
				});
				let d = Y(e.nodeName);
				if (!Dt(d, c, u)) {
					Q(a, e);
					continue;
				}
				if (E && typeof S == "object" && typeof S.getAttributeType == "function" && !o) switch (S.getAttributeType(d, c)) {
					case "TrustedHTML":
						u = E.createHTML(u);
						break;
					case "TrustedScriptURL":
						u = E.createScriptURL(u);
						break;
				}
				if (u !== l) try {
					o ? e.setAttributeNS(o, a, u) : e.setAttribute(a, u), wt(e) ? Z(e) : ne(t.removed);
				} catch {
					Q(a, e);
				}
			}
			$(O.afterSanitizeAttributes, e, null);
		}, At = function e(t) {
			let n = null, r = Ct(t);
			for ($(O.beforeSanitizeShadowDOM, t, null); n = r.nextNode();) $(O.uponSanitizeShadowNode, n, null), Et(n), kt(n), n.content instanceof o && e(n.content);
			$(O.afterSanitizeShadowDOM, t, null);
		};
		return t.sanitize = function(e) {
			let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = null, a = null, s = null, c = null;
			if (ut = !e, ut && (e = "<!-->"), typeof e != "string" && !Tt(e)) if (typeof e.toString == "function") {
				if (e = e.toString(), typeof e != "string") throw _("dirty is not a string, aborting");
			} else throw _("toString is not a function");
			if (!t.isSupported) return e;
			if (et || vt(n), t.removed = [], typeof e == "string" && (B = !1), B) {
				if (e.nodeName) {
					let t = Y(e.nodeName);
					if (!k[t] || M[t]) throw _("root node is forbidden and cannot be sanitized in-place");
				}
			} else if (e instanceof u) r = St("<!---->"), a = r.ownerDocument.importNode(e, !0), a.nodeType === T.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? r = a : r.appendChild(a);
			else {
				if (!L && !P && !I && e.indexOf("<") === -1) return E && z ? E.createHTML(e) : e;
				if (r = St(e), !r) return L ? null : z ? D : "";
			}
			r && tt && Z(r.firstChild);
			let l = Ct(B ? e : r);
			for (; s = l.nextNode();) Et(s), kt(s), s.content instanceof o && At(s.content);
			if (B) return e;
			if (L) {
				if (R) for (c = Fe.call(r.ownerDocument); r.firstChild;) c.appendChild(r.firstChild);
				else c = r;
				return (A.shadowroot || A.shadowrootmode) && (c = Le.call(i, c, !0)), c;
			}
			let d = I ? r.outerHTML : r.innerHTML;
			return I && k["!doctype"] && r.ownerDocument && r.ownerDocument.doctype && r.ownerDocument.doctype.name && g(De, r.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + r.ownerDocument.doctype.name + ">\n" + d), P && ee([
				Re,
				ze,
				Be
			], (e) => {
				d = m(d, e, " ");
			}), E && z ? E.createHTML(d) : d;
		}, t.setConfig = function() {
			vt(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), et = !0;
		}, t.clearConfig = function() {
			X = null, et = !1;
		}, t.isValidAttribute = function(e, t, n) {
			return X || vt({}), Dt(Y(e), Y(t), n);
		}, t.addHook = function(e, t) {
			typeof t == "function" && f(O[e], t);
		}, t.removeHook = function(e, t) {
			if (t !== void 0) {
				let n = te(O[e], t);
				return n === -1 ? void 0 : re(O[e], n, 1)[0];
			}
			return ne(O[e]);
		}, t.removeHooks = function(e) {
			O[e] = [];
		}, t.removeAllHooks = function() {
			O = je();
		}, t;
	}
	t.exports = Me();
}));
//#endregion
export default t();
export { t as require_purify_cjs };
